var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGuardUnlock = function SvgGuardUnlock(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4",
    width: 32,
    height: 32,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    transform: "translate(-589.51 -558.59)scale(.39057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_2",
    d: "M1529.4 1464.9c-3.86 0-6.97 3.12-6.97 6.98v33.03c0 3.86 3.11 6.97 6.97 6.97h44.78c3.86 0 6.97-3.11 6.97-6.97v-33.03c0-3.86-3.11-6.98-6.97-6.98zm22.39 14.68c3.24 0 5.87 2.63 5.87 5.88 0 2.17-1.18 4.03-2.93 5.04v8.17h-5.87v-8.17c-1.76-1.01-2.94-2.87-2.94-5.04 0-3.25 2.63-5.88 5.87-5.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1",
    strokeWidth: 1.001,
    d: "M1556.3 1432c-11.85-3.98-24.23 1.02-27.64 11.18-1.63 4.84 6.22 8.91 9.29 3.72 3.07-5.17 9.38-7.68 15.26-5.7 6.78 2.28 10.41 9.64 8.11 16.48l-2.282 7.266 10.46.074 2.082-7.41c3.42-10.15-3.42-21.62-15.28-25.61z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGuardUnlock);
export default ForwardRef;